import styled from 'styled-components';
import { Popover } from 'antd';

export const garageInfoLayout = {
  display: 'flex',
  flexWrap: 'wrap',
};

export const garageInfoCol = {
  width: '130px',
  flexBasis: '50%',
  marginBottom: '20px',
};

export const StyledPopoverContent = styled.div`
  font-size: 14px;
  h3 {
    margin-bottom: 5px;
    color: black;
    font-size: 14px;
  }
  .ant-alert {
    margin-top: '10px';
    font-size: '12px';
    font-weight: bold;
    padding: 12px;
  }
`;

export const StyledPopoverTitle = styled.div`
  padding: 10px 0;
  font-weight: bold;
`;

export const GarageInfoStyled = styled(Popover)`
  cursor: pointer;
`;

export const ViewGarageLink = styled.a`
  float: right;
  font-weight: bold;
`;
